import styled from "styled-components";
import { colors } from "~/assets/js/theme/constants";
import { disableMouseEvents } from "../../theme/mixins";

export const ANIM_DURATION = 500;
export const ANIM_TIMING_FUNCTION = "ease-out";

export const Overlay = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    transition: transform ${ANIM_DURATION}ms;
    transition-timing-function: ${ANIM_TIMING_FUNCTION};
    z-index: 21005;
    ${disableMouseEvents}
`;

export const BottomDwellerContainer = styled.div`
    background-color: ${colors.WHITE};
    border-radius: 25px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    display: flex;
    flex-direction: column;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    max-height: 100%;
    height: ${(props) => props.bottomOffset}px;
    &.expanded {
        height: 90%;
        //height: -webkit-fill-available;
    }
    box-shadow: 0 0 50px #00000060;
    transition-timing-function: ${ANIM_TIMING_FUNCTION};
    z-index: 21000;
    touch-action: none;
    margin-top: ${(props) => props.topOffset}px;
`;

export const Backdrop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1000;
    background-color: ${colors.BLACK};
    opacity: 0;
    ${disableMouseEvents}//transition: ${ANIM_DURATION}ms;
`;

export const GrabMeContainer = styled.div`
    overflow: hidden;
    height: 40px;
    min-height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

export const GrabMe = styled.div`
    height: 4px;
    width: 40px;
    background-color: ${colors.LAYOUT.GRAY[300]};
    border-radius: 2px;
`;

export const ContentContainer = styled.div`
    overflow: hidden;
    flex: 1;
`;
